import { type ReactNode, useId } from 'react';

import FormField from '@/components/atoms/FormField';

interface PanelFieldProps {
    label: string;
    /** Gets the label's id, which the control names itself by. */
    children: (labelId: string) => ReactNode;
}

/**
 * A panel row for a control that is a button rather than an input, so a `<label for>`
 * cannot name it: the label sits beside it and the control points back to it.
 */
export default function PanelField({ label, children }: PanelFieldProps) {
    // React's ids hold colons, which jsdom's selector engine cannot match in tests.
    const labelId = useId().replaceAll(':', '');
    return (
        <FormField layout="inline" label={label} labelId={labelId}>
            {children(labelId)}
        </FormField>
    );
}
